import { getFunctions, httpsCallable } from 'firebase/functions';

// Claim number format: YCP-{COMMITTEE}-{YEAR}-{SEQ4}
//
// Generation runs server-side in the nextClaimNumber Cloud Function.
// It cannot run on the client: finding the highest existing number
// requires scanning the claims collection, and Firestore rules deny
// any query a non-admin cannot fully satisfy. The function runs as
// Admin SDK and sees the whole collection.

export function formatClaimNumber(committee, year, seq) {
  const c = String(committee || 'UNK').replace('-', '');
  return 'YCP-' + c + '-' + year + '-' + String(seq).padStart(4, '0');
}

// True when the value is an issued claim number (YCP-... from the committee sequence, or a tester's EXAMPLE-...).
// Bob 2026-10-14, the walk-through: a draft filed from its claim page kept no number, because the page tested `claim.id`,
// which on that page is always the document id. Test the stored number by its shape instead.
export function isIssuedClaimNumber(v) {
  return /^(?:YCP|EXAMPLE)-[A-Z0-9]+-\d{4}-[A-Z0-9]+$/.test(String(v || ''));
}

export async function nextClaimNumber(committee) {
  const fn = httpsCallable(getFunctions(), 'nextClaimNumber');
  const res = await fn({ committee: committee });
  return res.data.claimNumber;
}